const environment = {
  production: {
    apiPath: process.env.APIPATH || 'https://www.takemetour.com/api',
    mainPath: 'https://www.takemetour.com',
    mediaPath: 'https://d2d3n9ufwugv3m.cloudfront.net',
  },
  staging: {
    apiPath: process.env.APIPATH || 'https://staging.takemetour.com/api',
    mainPath: 'https://staging.takemetour.com',
    mediaPath: 'https://dja3e86j343dh.cloudfront.net',
  }
}[process.env.NODE_ENV || 'development'];

export default Object.assign({
  apiPath: process.env.APIPATH || 'https://staging.takemetour.com/api',
  mainPath: 'https://staging.takemetour.com',
  mediaPath: 'https://dja3e86j343dh.cloudfront.net',
}, environment);



// WEBPACK FOOTER //
// ./src/config.js